<template>
  <div style="display: flex">
    <div style="width: 480px; height: 100%; background-color: #f7f7f8">
      <div style="display: flex;">
        <b-input-group style="margin: 8px; width: 77%">
          <b-form-input
            v-model="keyword"
            @keydown.enter="onSearch(true)"
          ></b-form-input>
          <b-input-group-append>
            <b-button
              variant="white"
              class="transparent"
              @click="onSearch(true)"
            >
              <b-icon icon="search" variant="primary"></b-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <b-button
          :class="[
                  hasFilterString
                    ? 'filter-btn-blue'
                    : 'filter-btn-gray',
                ]"
          class="filter-btn-gray"
          style="border-radius: 0;font-family: KoreanGD14R;font-size: 18px;height:62px;"
          variant="white"
          @click="initFilterBtn"
        >
          {{ $t("common.reset") }}
        </b-button>
      </div>
      <div style="display: flex">
        <b-button
          :class="['toggle_btn filter-btn-blue'/*, hasFilter && 'selected'*/]"
          style="font-size: 18px; border: none;font-family: 'KoreanGD15R';"
          :style="{ 'background-color': hasFilterString ? '#267fff' : '#e8f1fe', color: hasFilterString ? 'white' : 'black' }"
          :pressed="hasFilter || visibleFilter(F.TF_ALL)"
          variant="white" @click="setTFilter(F.TF_ALL)">{{realFilterString === '' ? $t('map.filter_set') : realFilterString}}</b-button>
<!--        <b-button class="toggle_btn" @click="setTFilter(F.TF_ALL)">-->
<!--          <b-img :src="[hasFilter ? require('../../../../assets/image/ic_option_on@2x.png') : require('../../../../assets/image/ic_option@2x.png')]" style="height: 1.5em"/>-->
<!--        </b-button>-->
      </div>
      <div class="site-list-container" ref="siteListContainer" @scroll="onScroll">
        <div>
          <div style="display: flex; padding: 8px 0">
            <div slot="checkbox_right" class="align-horizontal ml-2" style="" @click="
                  $store.commit('setFilter', {show_site_inquire_only: $store.getters.filter.show_site_inquire_only === 'Y' ? 'N' : 'Y'});
                  onSearch(true);
        ">
              <md-search-single-check-box :label="$t('site_detail.site_inquire_view')" :state="$store.getters.filter.show_site_inquire_only === 'N' ? false : true" />
            </div>
            <div class="align-horizontal flex_1 h_align_right">
              <MFSelect
                class="sort_btn sort-site-select"
                :drop="false"
                :vmodel="sortSite == 0 ? $t('map.sort_site') : $t('map.sort_ho')"
                @change="(value) => {
                  sortSite = value == $t('map.sort_site') ? 0 : 1
                  onSearch(true)
                }"
                :options="[$t('map.sort_site'), $t('map.sort_ho')]"
              />
              <!-- <b-form-select
                v-model="sortSite"
                class="sort_btn sort-site-select"
                @change="onSearch(true);">
                <option v-for="(value, idx) in [$t('map.sort_site'), $t('map.sort_ho')]" :key="idx" :value="idx">
                  {{value}}
                </option>
              </b-form-select> -->
              <div class="sort-site-split" />
              <MFSelect
                class="sort_btn sort-site-select"
                :drop="false"
                :vmodel="sortPrice == 'PL' ? $t('map.sort_price_low') : $t('map.sort_price_high')"
                @change="(value) => {
                  sortPrice = value == $t('map.sort_price_low') ? 'PL' : 'PH'
                  onSearch(true)
                }"
                :options="st_label"
              />
              <!-- <b-form-select
                v-model="sortPrice"
                class="sort_btn sort-site-select"
                @change="onSearch(true)">
                <option v-for="(value, key, idx) in st_label" :key="idx" :value="key">
                  {{value}}
                </option>
              </b-form-select> -->
            </div>
          </div>
          <SiteItem
            v-for="(item, i) in mapList"
            v-if="pinItem === null"
            :key="i"
            :id="'item' + i"
            :show-btn="true"
            :item="item"
            :detail-popup-align="'left'"
            :hoMode="sortSite === 1"
            :pageName="'Map'"
            @completeReport="onCompleteReport"
          />
          <SiteItem
            v-if="pinItem !== null"
            :key="0"
            :id="item0"
            :show-btn="true"
            :item="pinItem"
            :hoMode="sortSite === 1"
            @completeReport="onCompleteReport"
          />
        </div>
        <div class="full center flex-column" style="background-color: white" v-if="mapList.length === 0">
          <img src="../../../../assets/image/ic_no_data.png" style="height: 50px"/>
          <span class="no_item">{{$t('map.no_matched_site')}}</span>
        </div>
      </div>
      <!-- 필터구역 -->
      <div
        class="action-area"
        v-if="visibleFilter(F.TF_ALL, true)"
        style="z-index: 100; position: absolute; width: 480px; top: 115px; max-height: calc(100vh - (62px + 36px + 95px));"
      >
        <MFCategory v-if="visibleFilter(F.TF_CATEGORY, true)" />
        <!--          <MFSiteType v-if="visibleFilter(F.TF_SITE_TYPE, true)" />-->
        <MFShape v-if="visibleFilter(F.TF_SHAPE, true)" />
        <MFRoom v-if="visibleFilter(F.TF_ROOM, true)" />
        <MFArea v-if="false && visibleFilter(F.TF_AREA, true)" />
        <MFR v-if="false && visibleFilter(F.TF_R, true)" />
        <MFPeriod v-if="false && visibleFilter(F.TF_PERIOD, true)" />
        <div class="action-area-button">
          <b-button
            class="filter-btn-gray"
            variant="white"
            @click="onTFCancel"
          >
            {{ $t("common.cancel") }}
          </b-button>
          <b-button
            v-if="sh_tfilter == F.TF_ALL"
            variant="white"
            class="filter-btn-lblue"
            @click="initFilter"
          >
            {{ $t("common.reset") }}
          </b-button>
          <b-button
            variant="white"
            :class="[
                  sh_tfilter == F.TF_ALL
                    ? 'filter-btn-blue'
                    : 'filter-btn-lblue',
                ]"
            @click="onTFApply"
          >
            {{ $t("common.apply") }}
          </b-button>
        </div>
      </div>
    </div>
    <div class="filter-container" style="left: 480px; display: none">
      <div class="container">
        <b-input-group class="mt-4">
          <b-form-input
            v-model="keyword"
            @keydown.enter="onSearch(true)"
          ></b-form-input>
          <b-input-group-append>
            <b-button
              variant="white"
              class="transparent"
              @click="onSearch(true)"
            >
              <b-icon icon="search" variant="primary"></b-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <div class="fb-container">
          <template v-if="false">
            <b-button
              variant="white"
              size="sm"
              @click="setTFilter(F.TF_CATEGORY)"
              :pressed="hasCategoryFilter || visibleFilter(F.TF_CATEGORY)"
            >{{ $t("map.all") }}
              <b-icon icon="BIconChevronDown" class="icon_down"></b-icon
              ></b-button>
            <b-button
              variant="white"
              size="sm"
              @click="setTFilter(F.TF_ROOM)"
              :pressed="hasRoomFilter || visibleFilter(F.TF_ROOM)"
            >{{ $t("map.room") }}
              <b-icon icon="BIconChevronDown" class="icon_down"></b-icon
              ></b-button>
            <b-button
              variant="white"
              size="sm"
              @click="setTFilter(F.TF_SHAPE)"
              :pressed="hasShapeFilter || visibleFilter(F.TF_SHAPE)"
            >{{ $t("map.shape") }}
              <b-icon icon="BIconChevronDown" class="icon_down"></b-icon
              ></b-button>
            <b-button
              variant="white"
              size="sm"
              @click="setTFilter(F.TF_AREA)"
              :pressed="hasAreaFilter || visibleFilter(F.TF_AREA)"
            >{{ $t("map.area") }}
              <b-icon icon="BIconChevronDown" class="icon_down"></b-icon
              ></b-button>
            <b-button
              variant="white"
              size="sm"
              @click="setTFilter(F.TF_R)"
              :pressed="hasRFilter || visibleFilter(F.TF_R)"
            >{{ $t("map.r") }}
              <b-icon icon="BIconChevronDown" class="icon_down"></b-icon
              ></b-button>
            <b-button
              variant="white"
              size="sm"
              @click="setTFilter(F.TF_PERIOD)"
              :pressed="hasPeriodFilter || visibleFilter(F.TF_PERIOD)"
            >{{ $t("map.period") }}
              <b-icon icon="BIconChevronDown" class="icon_down"></b-icon
              ></b-button>
            <b-button
              variant="white"
              size="sm"
              @click="setTFilter(F.TF_ALL)"
              :pressed="hasFilterString || visibleFilter(F.TF_ALL)"
              class="transparent"
              style="padding-left: 5px"
            >{{ $t("map.filter_all") }}
              <b-icon
                icon="BIconSliders"
                class="icon_down"
                v-bind:class="{
                'text-primary': hasFilterString || visibleFilter(F.TF_ALL),
              }"
              ></b-icon>
            </b-button>
          </template>
          <template v-else>
            <b-button
              class="toggle_btn"
              @click="setTFilter(F.TF_ALL)"
              :pressed="hasFilterString || visibleFilter(F.TF_ALL)"
              variant="white">{{(hasFilterString) ? $t('map.filter_been_set') : $t('map.filter_set')}}</b-button>
            <b-button
              class="toggle_btn"
              @click="foldSaleList()"
              :pressed="showSaleList"
              variant="white">{{showSaleList ? $t('map.fold_list') : $t('map.unfold_list')}}</b-button>
          </template>
        </div>
      </div>
    </div>
    <div class="map-container" style="left: 480px; top: 0; right: 0">
      <div
        class="container align-vertical"
        :style="{ height: sh_bfilter ? 'calc(100% - 270px)' : '100%' }"
      >
        <div class="mfr-area">
          <!-- 지도구역 -->
          <div class="map-area" style="width: 100%">
            <!-- 여기에 지도를 배치하여야 합니다. -->
            <iframe
              ref="webref"
              id="webref"
              @load="onLoadEnd"
              class="map-area"
              style="width: 100%;border: 0;"
              src="https://app.madepf.com/map_test_vue.html?v=6"
            ></iframe>
          </div>
          <b-button
            v-if="!IS_TMP_MODE&&!showRV"
            @click="$router.push('SiteReport')"
            variant="white"
            class="site_report_btn"
            style="top: 30px;"
            >{{ $t("map.site_report") }}</b-button
          >

          <div
            style="position: absolute; bottom: 100px; right: 10px; z-index: 5"
          >
            <b-button
              v-if="!showRV"
              pill
              class="map align-horizontal center p-0"
              style="background-color: transparent"
              @click="onRoadView"
            >
              <!--          <b-icon icon="BIconGeoAlt"></b-icon>-->
              <b-img
                v-if="showLoadView"
                class="map_gps_btn"
                :src="
                  require('../../../../assets/image/ic_roadview_on@2x.png')
                "
              />
              <b-img
                v-else
                class="map_gps_btn"
                :src="
                  require('../../../../assets/image/ic_roadview@2x.png')
                "
              />
            </b-button>
            <b-button
              v-if="!showRV"
              pill
              class="map align-horizontal center p-0"
              style="background-color: transparent"
              @click="onDistance"
            >
              <!--          <b-icon icon="BIconGeoAlt"></b-icon>-->
              <b-img
                v-if="showDistance"
                class="map_gps_btn"
                :src="
                  require('../../../../assets/image/ic_distance_off@2x.png')
                "
              />
              <b-img
                v-else
                class="map_gps_btn"
                :src="
                  require('../../../../assets/image/ic_distance_start@2x.png')
                "
              />
            </b-button>
            <b-button
              v-if="!showRV"
              pill
              class="map align-horizontal center p-0"
              style="background-color: transparent"
              @click="onRadius"
            >
              <!--          <b-icon icon="BIconGeoAlt"></b-icon>-->
              <b-img
                v-if="showRadius"
                class="map_gps_btn"
                :src="require('../../../../assets/image/ic_radius_off@2x.png')"
              />
              <b-img
                v-else
                class="map_gps_btn"
                :src="
                  require('../../../../assets/image/ic_radius_start@2x.png')
                "
              />
            </b-button>
            <b-button
              v-if="!showRV"
              @click="onFavorite"
              style="background-color: transparent"
              pill
              class="map ifilter align-horizontal center p-0"
            >
              <!--          {{$t('map.init_filter')}}-->
              <b-img
                v-if="setFavorite"
                class="map_gps_btn"
                :src="require('../../../../assets/image/ic_favorite_sale_on@2x.png')"
              />
              <b-img
                v-else
                class="map_gps_btn"
                :src="require('../../../../assets/image/ic_favorite_sale_off@2x.png')"
              />
            </b-button>
            <b-button
              v-if="!showRV"
              @click="initFilterBtn"
              style="background-color: transparent"
              pill
              class="map ifilter align-horizontal center p-0"
            >
              <!--          {{$t('map.init_filter')}}-->
              <b-img
                v-if="hasFilterString"
                class="map_gps_btn"
                :src="require('../../../../assets/image/ic_filter_on@2x.png')"
              />
              <b-img
                v-else
                class="map_gps_btn"
                :src="require('../../../../assets/image/ic_filter_off@2x.png')"
              />
            </b-button>
            <b-button
              v-if="!showRV"
              pill
              class="map align-horizontal center p-0"
              style="background-color: transparent"
              @click="onGPS"
            >
              <!--          <b-icon icon="BIconGeoAlt"></b-icon>-->
              <b-img
                v-if="showGps"
                class="map_gps_btn"
                :src="require('../../../../assets/image/ic_gps_on@2x.png')"
              />
              <b-img
                v-else
                class="map_gps_btn"
                :src="require('../../../../assets/image/ic_gps@2x.png')"
              />
            </b-button>
          </div>
        </div>
        <div
          ref="currentSale"
          class="current-sale container"
          :style="{ top: saleTop + 'px', paddingBottom: '6em' }"
          style="z-index: 200; display: none"
        >
          <template v-if="!showSaleList">
            <div class="center drop-arrow mb-2" @click="toggleDetail(false)">
              <b-img
                :src="require('../../../../assets/image/ic_detail_drop@2x.png')"
                style="height: 1em"
              />
            </div>
          </template>
          <template v-else>
            <div class="align-horizontal margin-top-15 mb-2">
              <b-button
                class="sort_btn"
                :pressed="$store.getters.filter.show_site_inquire_only === 'Y'"
                @click="
                  $store.commit('setFilter', {show_site_inquire_only: $store.getters.filter.show_site_inquire_only === 'Y' ? 'N' : 'Y'});
                  onSearch(true);
                "
                variant="white">
                {{$t('site_detail.site_inquire')}}
              </b-button>
              <div class="align-horizontal flex_1 h_align_right">
                <MFSelect
                  class="sort_btn"
                  :drop="false"
                  :vmodel="sortSite == 0 ? $t('map.sort_site') : $t('map.sort_ho')"
                  @change="(value) => {
                    sortSite = value == $t('map.sort_site') ? 0 : 1
                    onSearch(true)
                  }"
                  :options="[$t('map.sort_site'), $t('map.sort_ho')]"
                />
                <!-- <b-form-select
                  v-model="sortSite"
                  class="sort_btn"
                  @change="onSearch(true);">
                  <option v-for="(value, idx) in [$t('map.sort_site'), $t('map.sort_ho')]" :key="idx" :value="idx">
                    {{value}}
                  </option>
                </b-form-select> -->
                <MFSelect
                  class="sort_btn"
                  :drop="false"
                  :vmodel="sortPrice == 'PL' ? $t('map.sort_price_low') : $t('map.sort_price_high')"
                  @change="(value) => {
                    sortPrice = value == $t('map.sort_price_low') ? 'PL' : 'PH'
                    onSearch(true)
                  }"
                  :options="st_label"
                />
                <!-- <b-form-select
                  v-model="sortPrice"
                  class="sort_btn"
                  @change="onSearch(true)">
                  <option v-for="(value, key, idx) in st_label" :key="idx" :value="key">
                    {{value}}
                  </option>
                </b-form-select> -->
              </div>
            </div>
          </template>
          <SiteItem
            v-for="(item, i) in mapList"
            :key="i"
            :id="'item' + i"
            :show-btn="true"
            :item="item"
            :hoMode="sortSite === 1"
            @completeReport="onCompleteReport"
          />
        </div>
        <!-- <b-button
          @click="toggleDetail"
          v-if="showTotalBar"
          style="z-index: 250"
          variant="white"
          class="mfr-bar"
          >{{ u.format($t("map.current_show_sale"), totalCount) }}</b-button> -->

        <div
          ref="currentListSale"
          class="current-sale container"
          :style="{ top: saleListTop + 'px', paddingBottom: '6em' }"
          style="z-index: 200; overflow-y: auto;  display: none"
        >
          <template v-if="false">
            <div class="center drop-arrow mb-2" @click="toggleListDetail(false)">
              <b-img
                :src="require('../../../../assets/image/ic_detail_drop@2x.png')"
                style="height: 1em"
              />
            </div>
          </template>
          <template>
            <div class="align-horizontal margin-top-15 mb-2">
              <b-button
                class="sort_btn"
                :pressed="$store.getters.filter.show_site_inquire_only === 'Y'"
                @click="
                  $store.commit('setFilter', {show_site_inquire_only: $store.getters.filter.show_site_inquire_only === 'Y' ? 'N' : 'Y'});
                  onSearch(true);
                "
                variant="white">
                {{$t('site_detail.site_inquire')}}
              </b-button>
              <div class="align-horizontal flex_1 h_align_right">
                <MFSelect
                  class="sort_btn"
                  :drop="false"
                  :vmodel="sortSite == 0 ? $t('map.sort_site') : $t('map.sort_ho')"
                  @change="(value) => {
                    sortSite = value == $t('map.sort_site') ? 0 : 1
                    onSearch(true)
                  }"
                  :options="[$t('map.sort_site'), $t('map.sort_ho')]"
                />
                <!-- <b-form-select
                  v-model="sortSite"
                  class="sort_btn"
                  @change="onSearch(true);">
                  <option v-for="(value, idx) in [$t('map.sort_site'), $t('map.sort_ho')]" :key="idx" :value="idx">
                    {{value}}
                  </option>
                </b-form-select> -->
                <MFSelect
                  class="sort_btn"
                  :drop="false"
                  :vmodel="sortPrice == 'PL' ? $t('map.sort_price_low') : $t('map.sort_price_high')"
                  @change="(value) => {
                    sortPrice = value == $t('map.sort_price_low') ? 'PL' : 'PH'
                    onSearch(true)
                  }"
                  :options="st_label"
                />
                <!-- <b-form-select
                  v-model="sortPrice"
                  class="sort_btn"
                  @change="onSearch(true)">
                  <option v-for="(value, key, idx) in st_label" :key="idx" :value="key">
                    {{value}}
                  </option>
                </b-form-select> -->
              </div>
            </div>
          </template>
          <SiteItem
            v-for="(item, i) in searchMapList"
            :key="i"
            :id="'item' + i"
            :show-btn="true"
            :item="item"
            :hoMode="sortSite === 1"
            @completeReport="onCompleteReport"
          />
        </div>
      </div>
      <b-button class="back_btn" @click="() => {this.pinItem = null; this.showBack= false; this.onSearch(false, false);}" v-if="showBack" style="padding: 0px; height: 50px; background-color: transparent; border-color: transparent">
        <img src="../../../../assets/image/btn_back_map.png" style="height: 50px"/>
      </b-button>
      <MFMap @facilityClick="onFacilityClick" v-if="sh_bfilter" />
    </div>

    <SiteReportPopup :visible.sync="showSiteReportPopup" :item="currentItem" />
    <Navbar
      ref="currentBottomMenu"
    />
  </div>
</template>

<script>
import Navbar from "../../../controls/navbar";
import MFCategory from "../../../controls/mf/MFCategory";
import MFSiteType from "../../../controls/mf/MFSiteType";
import MFRoom from "../../../controls/mf/MFRoom";
import MFShape from "../../../controls/mf/MFShape";
import MFArea from "../../../controls/mf/MFArea";
import MFR from "../../../controls/mf/MFR";
import MFPeriod from "../../../controls/mf/MFPeriod";
import MFMap from "../../../controls/mf/MFMap";
import MFSelect from "../../../controls/mf/MFSelect";
import SiteItem from "../../../controls/SiteItem";
import Utils from "../../../../config/utils";
import SiteReportPopup from "../../../controls/popup/SiteReportPopup";
import { IS_TMP_MODE } from "../../../../config/constant";
import i18n from "../../../../../src/i18n"
import MdSingleCheckBox from "../../../controls/mf/MdSingleCheckBox";
import MdSearchSingleCheckBox from "../../../controls/mf/MdSearchSingleCheckBox";

const u = require("util");

const SCROLL_HEADER_HEIGHT = 45;
const SITE_ITEM_HEIGHT = 330;
const ANIMATION_TIME = 200;
const TOTAL_BAR_HEIGHT = 38;
const SORT_TYPE = [
  'PL', 'PH', /*'CL', 'CH'*/
]
const SORT_TYPE_LABEL = {
  'PL': i18n.t('map.sort_price_low'),
  'PH': i18n.t('map.sort_price_high'),
  /*'CL': i18n.t('map.sort_collateral_low'),
  'CH': i18n.t('map.sort_collateral_high')*/
}

let INTRO_TIME = 1000;
let startTime = new Date().getTime();

export default {
  name: "Map",
  components: {
    Navbar,
    MFCategory,
    MFSiteType,
    MFRoom,
    MFShape,
    MFArea,
    MFR,
    MFPeriod,
    MFMap,
    MFSelect,
    SiteItem,
    SiteReportPopup,
    MdSingleCheckBox,
    MdSearchSingleCheckBox
  },
  data: function () {
    return {
      IS_TMP_MODE: IS_TMP_MODE,
      showSiteReportPopup: false,
      currentItem: null,
      u: u,
      util: Utils,
      st_label: SORT_TYPE_LABEL,
      keyword: this.$store.getters.filter.keyword,
      F: {
        NONE: 0,
        TF_CATEGORY: 1,
        TF_SITE_TYPE: 2,
        TF_ROOM: 4,
        TF_SHAPE: 8,
        TF_AREA: 16,
        TF_R: 32,
        TF_PERIOD: 64,
        TF_ALL: 127,
      },
      isShowingDetail: false,
      showGps: false,
      showLoadView: false,
      showRV: false,
      showDistance: false,
      showRadius: false,
      sh_bfilter: false, // 아래부분 필터 보기상태
      sh_tfilter: false, //매물형태, 화면에서 웃부분 필터보기
      showSaleList: false, //목록열기상태관리기발
      saleTop: 0,
      saleListTop: 0,
      showFacility: false,
      showTotalBar: false,
      // fcTab: FC_TAB.CONV,
      list: [],
      step: 3,
      mapList: [],
      searchMapList: [],
      totalCount: 0,

      useKeyword: true, // keyword use or not
      loadingEnd: false,

      setFavorite: false,
      sortSite: 0,
      sortPrice: "PL", // PL: 낮은 순, PH: 높은 순, CL: 담보 낮은 순, CH: 담보 높은 순
      pinItem: null,
      showBack: false,
      hasFilterString: false,
      realFilterString: "",
    };
  },
  methods: {
    onSiteDetailLike(site_idx) {
      Utils.setState(this, {
        mapList: this.mapList.map((it) => {
          if (it.f_idx == site_idx) {
            it.f_like = it.f_like == "Y" ? "N" : "Y";
          }
          return it;
        }),
      });
    },
    onCompleteReport(item) {
      this.currentItem = item;
      this.showSiteReportPopup = true;
    },

    onScroll(){
      if (this.searchMapList.length === 0)
        return;
      else {
        let wrap = this.$refs.siteListContainer;
        if(wrap.scrollHeight - Math.ceil(wrap.scrollTop) === wrap.clientHeight){ //end of scroll
          if (!this.loadingEnd){
            this.getRenderList();
          }
        }
      }
    },

    onMessage(e) {
      if (this.showDetail) {
        this.toggleDetail(false);
      }

      try {
        let data = JSON.parse(e.data);
        if (data.type == "1") {
          Utils.requestGet(this.$c.API.Site.searchSiteListByPos, {
            lat: data.lat,
            lng: data.lon,
          }).then((result) => {
            if (result.code == this.$c.API_RES_CODE.SUCCESS) {
              console.log(data.lon);
              console.log(result.data.list);
              this.list = result.data.list;
              this.mapList = result.data.list;
              // this.pinItem = result.data.list; // YJ modify in 20230726
              this.showBack = true;
              this.totalCount = result.data.count;
              if (result.data.list.length < 1) {
                if (this.$store.getters.filter.keyword != "") {
                  Utils.toast(this, this.$t("map.no_search_result"));
                }
                this.showTotalBar = false;
              } else {
                if (!this.showFacility) {
                  this.showTotalBar = true;
                  // console.log("totalCount : ", this.totalCount, " site_list_count:", this.mapList.length);
                  if (this.totalCount > 0) {
                    this.loadingEnd = false;
                    if (this.isShowingDetail) {
                      if (result.data.list.length > 0) {
                        this.scrollToItem(0);
                      }
                    }
                  }
                  if (this.totalCount > 1) {
                    this.toggleDetail(true);
                  } else {
                    console.log(result.data.list[0].f_transaction_type);
                    var count = -1;
                    if (result.data.list[0].f_transaction_type.split(',').includes('0')) {
                      count ++;
                    }
                    if (result.data.list[0].f_transaction_type.split(',').includes('1')) {
                      count ++;
                    }
                    if (result.data.list[0].f_transaction_type.split(',').includes('2')) {
                      count ++;
                    }
                    if (result.data.list[0].f_transaction_type.split(',').includes('3')) {
                      count ++;
                    }
                    var small_item_height = 40 * count;
                    //매물 1개인 경우(아래가 6가지 경우)
                    if (result.data.list[0].f_user_idx == this.myinfo.uid && result.data.list[0].f_site_type == "G") {
                      // 내 일반매물인 경우
                      if (result.data.list[0].f_memo != "") {
                        //메모가 있는 경우
                        this.toggleDetail(
                          true,
                          SITE_ITEM_HEIGHT + SCROLL_HEADER_HEIGHT + 25 + small_item_height
                        );
                      } else {
                        //메모가 없는 경우
                        this.toggleDetail(
                          true,
                          SITE_ITEM_HEIGHT + SCROLL_HEADER_HEIGHT + 18 - 53 + small_item_height
                        );
                      }
                    } else {
                      if (result.data.list[0].f_site_type == "G") {
                        // 타사용자 일반매물인 경우
                        if (result.data.list[0].f_memo != "") {
                          //메모가 있는 경우
                          this.toggleDetail(
                            true,
                            SITE_ITEM_HEIGHT + SCROLL_HEADER_HEIGHT - 35 + small_item_height
                          );
                        } else {
                          //메모가 없는 경우
                          this.toggleDetail(
                            true,
                            SITE_ITEM_HEIGHT + SCROLL_HEADER_HEIGHT - 30 - 70 + small_item_height
                          );
                        }
                      } else {
                        // 타사용자 오픈현장인 경우
                        if (result.data.list[0].f_memo != "") {
                          //메모가 있는 경우
                          this.toggleDetail(
                            true,
                            SITE_ITEM_HEIGHT + SCROLL_HEADER_HEIGHT - 35 + small_item_height
                          );
                        } else {
                          //메모가 없는 경우
                          this.toggleDetail(
                            true,
                            SITE_ITEM_HEIGHT + SCROLL_HEADER_HEIGHT - 30 + small_item_height
                          );
                        }
                      }
                    }
                  }
                }
              }
            } else {
              Utils.toast(this, result.msg);
            }
          });
        } else if (data.type == "2") {
          this.showGps = false;
        } else if (data.type == "3") {
          Utils.toast(this, this.$t("거리 설정 후 마우스 우클릭을 눌러주세요."));
        } else if (data.type == "4") {
          Utils.toast(this, this.$t("반경 설정 후 마우스 우클릭을 눌러주세요."));
        } else if (data.type == "5") {
          this.$store.commit("setLoading", false);
          console.log("------------", this.$store.getters.filter.keyword, "---fac==", this.showFacility)
          if (this.$store.getters.filter.keyword != "") {
            this.toggleDetail(false);
          }
        } else if (data.type == "6") {
          if (this.$store.getters.filter.keyword != "") {
            Utils.toast(this, this.$t("map.no_search_result"));
            this.toggleDetail(false);
          }
        } else if (data.type == "20") { // 로드뷰 관련
          console.log("로드뷰 = " + data.rv);
          this.showRV = data.rv;
          this.$refs.currentBottomMenu.setTopMenu(!this.showRV);
        } else if (data.type == "-1") {
          // this.$store.commit("setLoading", true);
          Utils.toast(this, '매물을 불러오는 중입니다.');
        } else if (data.type == "-2") {
          // this.$store.commit("setLoading", false);
        }
      } catch (e) {

      }
     },

    showDetail(item) {
      let itemPos = this.mapList.findIndex((e) => e.f_idx == item.f_idx);
      // let scrollToHeight = 0;
      // if (itemPos > 0) {
      //   for (let i = 0; i < itemPos; i++) {
      //     scrollToHeight += Number(this._itemHeightList[i]);
      //   }
      // }
      if (this.isShowingDetail) {
        if (itemPos > -1) {
          this.scrollToItem(itemPos);
        } else {
          this.mapList = [item].concat(
            this.mapList.filter((it) => it.f_idx != item.f_idx)
          );
          this.scrollToItem(0);
        }
      } else {
        this.mapList = [item].concat(
          this.mapList.filter((it) => {
            return it.f_idx != item.f_idx;
          })
        );
        if (item.f_same_position == 1) {
          let itemPos2 = this.mapList.findIndex(
            (e) => e.f_idx != item.f_idx && e.f_same_position == 1
          );
          let item2 = this.mapList[itemPos2];
          this.mapList = [item2].concat(
            this.mapList.filter((it) => {
              return it.f_idx != item2.f_idx;
            })
          );
          let itemPos3 = this.mapList.findIndex(
            (e) =>
              e.f_idx != item.f_idx &&
              e.f_same_position == 1 &&
              e.f_idx != item2.f_idx
          );
          if (itemPos3 > 0) {
            let item3 = this.mapList[itemPos3];
            this.mapList = [item3].concat(
              this.mapList.filter((it) => it.f_idx != item3.f_idx)
            );
            this.scrollToItem(0);
            let itemHeight =
              itemPos > -1 ? this._itemHeightList[itemPos] : SITE_ITEM_HEIGHT;
            if (!itemHeight) {
              itemHeight = SITE_ITEM_HEIGHT;
            }

            if (item.f_same_position == 1) {
              this.toggleDetail(true);
            } else {
              this.toggleDetail(true, itemHeight + SCROLL_HEADER_HEIGHT);
            }
          } else {
            this.mapList = [item].concat(
              this.mapList.filter((it) => it.f_idx != item.f_idx)
            );
            this.scrollToItem(0);

            let itemHeight =
              itemPos > -1 ? this._itemHeightList[itemPos] : SITE_ITEM_HEIGHT;
            if (!itemHeight) {
              itemHeight = SITE_ITEM_HEIGHT;
            }

            if (item.f_same_position == 1) {
              this.toggleDetail(true);
            } else {
              this.toggleDetail(true, itemHeight + SCROLL_HEADER_HEIGHT);
            }
          }
        } else {
          this.scrollToItem(0);
          let itemHeight =
            itemPos > -1 ? this._itemHeightList[itemPos] : SITE_ITEM_HEIGHT;
          if (!itemHeight) {
            itemHeight = SITE_ITEM_HEIGHT;
          }

          if (item.f_same_position == 1) {
            this.toggleDetail(true);
          } else {
            this.toggleDetail(true, itemHeight + SCROLL_HEADER_HEIGHT);
          }
        }
      }
    },

    getReqParam(add_on = {}) {
      const transMap = { T: "0", C: "1", I: "2", M: "3" };
      return Object.assign(
        {},
        this.$store.getters.filter,
        {
          trans_type: this.$store.getters.filter.trans_type
            .split(",")
            .filter((it) => {
              return it != "";
            })
            .map((it) => {
              return transMap[it];
            })
            .join(","),
          sale_price_min: this.$store.getters.filter.sale_price_min * 100,
          sale_price_max: this.$store.getters.filter.sale_price_max * 100,
          charter_price_min: this.$store.getters.filter.charter_price_min * 100,
          charter_price_max: this.$store.getters.filter.charter_price_max * 100,
          invest_price_min: this.$store.getters.filter.invest_price_min * 100,
          invest_price_max: this.$store.getters.filter.invest_price_max * 100,
          monthly_rent_deposit_min:
            this.$store.getters.filter.monthly_rent_deposit_min * 100,
          monthly_rent_deposit_max:
            this.$store.getters.filter.monthly_rent_deposit_max * 100,
          monthly_rent_min: this.$store.getters.filter.monthly_rent_min,
          monthly_rent_max: this.$store.getters.filter.monthly_rent_max,
          sortSite: this.sortSite === 0, // false: 세대, true: 현장
        },
        add_on
      );
    },

    onSearch(showLoading = true, moveSts = true) {
      if (this.$store.getters.filter.keyword != "") {
        this.$store.commit("setFilter", { lat: this.myinfo.latitude });
        this.$store.commit("setFilter", { lng: this.myinfo.longitude });
      }
      if (this.$store.getters.filter.maxLat == 0) {
        this.$store.commit("setFilter", {
          maxLat: (this.myinfo.latitude * 2 + 0.068160053462094) / 2,
        });
        this.$store.commit("setFilter", {
          minLat: (this.myinfo.latitude * 2 - 0.068160053462094) / 2,
        });
        this.$store.commit("setFilter", {
          maxLng: (this.myinfo.longitude * 2 + 0.068160053462094) / 2,
        });
        this.$store.commit("setFilter", {
          minLng: (this.myinfo.longitude * 2 - 0.068160053462094) / 2,
        });
      }

      // if (this.$store.getters.filter.keyword != "" && moveSts) {
      if (this.$store.getters.filter.keyword) {
        this.useKeyword = true;
        if (this.realFilterString == "")
          this.hasFilterString = true;
      } else {
        this.useKeyword = false;
        if (this.realFilterString == "")
          this.hasFilterString = false;
      }
      const param = this.getReqParam({
        use_keyword: this.useKeyword ? 1 : 0,
        user_id: this.myinfo.uid,
        favorite: this.setFavorite ? 'Y' : 'N',
        sort_site: this.sortSite == 0 ? 'Y' : 'N',
        sort_price: this.sortPrice,
        offset: 0
      });

      if (true) { // PY에서 개발과정에 지도검색기능테스트를 위해 이용하였던 코드
        // const param = this.getReqParam({
        //   use_keyword: this.useKeyword ? 1 : 0,
        //   user_id: this.myinfo.uid,
        //   favorite: this.setFavorite ? 'Y' : 'N',
        //   sort_site: this.sortSite == 0 ? 'Y' : 'N',
        //   sort_price: this.sortPrice,
        //   offset: 0
        // });
        console.log("------param-------", param);
        Utils.requestPost(
          this.$c.API.Site.searchSiteForMap_app,
          param,
          showLoading
        ).then(result => {
          if (result.code == this.$c.API_RES_CODE.SUCCESS) {
            this.list = result.data.list;
            this.mapList = result.data.list;
            this.searchMapList = result.data.list;
            this.loadingEnd = result.data.list.length < 10;
            if (this.list.length < 1 && showLoading) {
              if (this.$store.getters.filter.keyword != "") {
                Utils.toast(this, this.$t('map.no_search_result'));
              }
              this.showTotalBar = false;

            } else {
              if (!this.showFacility) {
                this.showTotalBar = true;
                if (this.totalCount > 0) {
                  this.loadingEnd = false;
                  //TODO:
                }
              }
            }
          } else {
            Utils.toast(this, result.msg);
          }
        });
      }


      this.$refs.webref.contentWindow.postMessage(
        { type: "4", param: param, move: moveSts },
        "*"
      );
      if (this.showSaleList) {
        if (['CL', 'CH'].includes(this.sortPrice))
          Utils.toast(this, this.$t('map.sort_collateral_price_desc'));
        if (['PL', 'PH'].includes(this.sortPrice)) {
          if (this.$store.getters.filter.show_site_inquire_only == 'Y')
            Utils.toast(this, this.$t('map.show_site_inquire_only_desc'))
          else
            Utils.toast(this, this.$t('map.show_price_input_site_only_desc'));
        }
      }
    },

    onMapSearch(showLoading = true, moveSts = true) {
      if (this.$store.getters.filter.keyword != "") {
        this.$store.commit("setFilter", { lat: this.myinfo.latitude });
        this.$store.commit("setFilter", { lng: this.myinfo.longitude });
      }

      if (this.$store.getters.filter.keyword) {
        this.useKeyword = true;
      } else {
        this.useKeyword = false;
      }
      const param = this.getReqParam({
        use_keyword: this.useKeyword ? 1 : 0,
        user_id: this.myinfo.uid,
        favorite: this.setFavorite ? 'Y' : 'N',
        sort_site: this.sortSite == 0 ? 'Y' : 'N',
        sort_price: this.sortPrice,
        offset: 0
      });

      this.$refs.webref.contentWindow.postMessage(
        { type: "4", param: param, move: moveSts },
        "*"
      );
      if (this.showSaleList) {
        if (['CL', 'CH'].includes(this.sortPrice))
          Utils.toast(this, this.$t('map.sort_collateral_price_desc'));
        if (['PL', 'PH'].includes(this.sortPrice)) {
          if (this.$store.getters.filter.show_site_inquire_only == 'Y')
            Utils.toast(this, this.$t('map.show_site_inquire_only_desc'))
          else
            Utils.toast(this, this.$t('map.show_price_input_site_only_desc'));
        }
      }
    },

    getRenderList() {
      // if (moveSts && showLoading && this.$store.getters.filter.keyword != "") {
      //   this.$store.getters.filter.lat = this.myinfo.latitude;
      //   this.$store.getters.filter.lng = this.myinfo.longitude;
      // }
      // console.log("Total Count = " + this.totalCount);
      // if (this.totalCount == this.searchMapList.length) {
      //   return;
      // }

      const param = this.getReqParam({
        use_keyword: this.useKeyword ? 1 : 0,
        user_id:this.myinfo.uid,
        favorite: this.setFavorite ? 'Y' : 'N',
        sort_site: this.sortSite == 0 ? 'Y' : 'N',
        sort_price: this.sortPrice,
        offset: this.searchMapList.length,
      });
      Utils.requestPost(this.$c.API.Site.searchSiteForMap_app, param, true).then(
        (result) => {
          if (result.code == this.$c.API_RES_CODE.SUCCESS) {
            this.list = this.mapList.concat(result.data.list);
            this.mapList = this.mapList.concat(result.data.list);
            this.searchMapList = this.searchMapList.concat(result.data.list);
            this.loadingEnd = result.data.list.length < 10;
          } else {
            Utils.toast(this, result.msg);
          }
        }
      );
    },

    onDrawResult(moveSts) {
      // this.webref.postMessage(
      //   JSON.stringify({type: '4', list: this.list, move: moveSts, step: this.step})
      // );
    },

    toggleDetail(state = null, scrollHeight = null) {
      let self = this;
      if (this.saleTop == 0 || (state != null && !state) || (state == false && scrollHeight == null)) {
        //if visible or state = false
        this.saleTop = this.saleHeight; //hide sale
      } else {
        let timeId = setInterval(function () {
          self.isShowingDetail = true;
          if (self.saleTop > 0) {
            if (scrollHeight == null) {
              if (self.saleTop < 100) self.saleTop = 0;
              else self.saleTop -= 100;
            } else {
              if (self.saleTop < self.saleHeight - scrollHeight) {
                self.saleTop = self.saleHeight - scrollHeight;
                clearTimeout(timeId);
              } else {
                self.saleTop -= 100;
              }
            }
          } else {
            clearTimeout(timeId);
            self.isShowingDetail = false;
          }
        }, 10);
      }
    },

    toggleListDetail(state = null, scrollHeight = null) {
      let self = this;
      if (this.saleListTop == 0 || (state != null && !state) || (state == false && scrollHeight == null)) {
        //if visible or state = false
        this.saleListTop = this.saleListHeight; //hide sale
      } else {
        let timeId = setInterval(function () {
          self.isShowingDetail = true;
          if (self.saleListTop > 0) {
            if (scrollHeight == null) {
              if (self.saleListTop < 100) self.saleListTop = 0;
              else self.saleListTop -= 100;
            } else {
              if (self.saleListTop < self.saleListHeight - scrollHeight) {
                self.saleListTop = self.saleListHeight - scrollHeight;
                clearTimeout(timeId);
              } else {
                self.saleListTop -= 100;
              }
            }
          } else {
            clearTimeout(timeId);
            self.isShowingDetail = false;
          }
        }, 10);
      }
    },

    initFilter: function () {
      //this.hasFilterString = false;
      //this.realFilterString = "";
      this.keyword = "";
      this.$store.commit("initFilter");
      this.$store.commit("setBackupFilter");
      // this.onSearch(true, false);
    },
    initFilterBtn: function () {
      // this.initFilter();
      this.hasFilterString = false;
      this.realFilterString = "";
      this.keyword = "";
      this.$store.commit("initFilter");
      this.onSearch(true, false);
    },

    visibleFilter: function (v, or = false) {
      if (or) return (this.sh_tfilter & v) != 0;
      else return this.sh_tfilter == v;
    },

    setTFilter: function (v) {
      this.toggleDetail(false);
      this.toggleListDetail(false);
      this.showSaleList = false;
      if (v != this.sh_tfilter) this.sh_tfilter = v;
      else this.sh_tfilter = this.F.NONE;
      if (this.sh_tfilter != this.F.NONE) {
        this.$store.commit("setBackupFilter");
      }
    },

    foldSaleList: function () {
      this.toggleDetail(false);
      this.showSaleList = !this.showSaleList;
      this.sh_tfilter = this.F.NONE;

      if (this.showSaleList) {
        this.toggleListDetail(true);
        if (['CL', 'CH'].includes(this.sortPrice))
          Utils.toast(this, this.$t('map.sort_collateral_price_desc'));
        if (['PL', 'PH'].includes(this.sortPrice)) {
          if (this.$store.getters.filter.show_site_inquire_only == 'Y')
            Utils.toast(this, this.$t('map.show_site_inquire_only_desc'))
          else
            Utils.toast(this, this.$t('map.show_price_input_site_only_desc'));
        }
      } else {
        this.toggleListDetail(false);
      }
    },

    onTFApply: function () {
      this.hasFilterString = this.hasFilter;
      console.log("Map Apply :: ", this.hasFilter);
      this.realFilterString = this.filterString;
      this.sh_tfilter = this.F.NONE;
      this.$store.commit("setBackupFilter");
      this.onSearch(true, false);
    },

    onTFCancel: function () {
      this.$store.commit("setRestoreFilter");
      this.sh_tfilter = this.F.NONE;
    },
    onFavorite: function () {
      this.setFavorite = !this.setFavorite;
      this.onSearch(true, false);
    },
    toggleBFilter: function () {
      // this.sh_bfilter = !this.sh_bfilter;
      // this.showTotalBar = !this.sh_bfilter;
       Utils.toast(this, '개별 매물에서 확인해주세요.');
    },

    onGPS: function () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            this.myinfo.latitude = pos.coords.latitude;
            this.myinfo.longitude = pos.coords.longitude;
            this.$refs.webref.contentWindow.postMessage(
              {
                type: "3",
                lat: this.myinfo.latitude,
                lon: this.myinfo.longitude,
              },
              "*"
            );
          },
          (err) => {
            console.log("-------gps error-----", err);
            this.showGps = !this.showGps;
            Utils.toast(this, this.$t("map.no_gps_permission"));
          }
        );
      }

      this.showGps = !this.showGps;
    },

    onRoadView ()  {
      this.showLoadView = !this.showLoadView;
      this.$refs.webref.contentWindow.postMessage(
        { type: "8", state: this.showLoadView},
        '*'
      );
    },

    onDistance: function () {
      if (this.showDistance) {
        this.$refs.webref.contentWindow.postMessage(
          {
            type: "5",
            state: "2",
          },
          "*"
        );
      } else {
        this.$refs.webref.contentWindow.postMessage(
          {
            type: "5",
            state: "1",
          },
          "*"
        );
      }

      this.showDistance = !this.showDistance;
    },

    onRadius: function () {
      if (this.showRadius) {
        this.$refs.webref.contentWindow.postMessage(
          {
            type: "6",
            state: "2",
          },
          "*"
        );
      } else {
        this.$refs.webref.contentWindow.postMessage(
          {
            type: "6",
            state: "1",
          },
          "*"
        );
      }

      this.showRadius = !this.showRadius;
    },

    scrollToItem(index) {
      let rect0 = this.$el.querySelector("#item0").getBoundingClientRect();
      let rect1 = this.$el
        .querySelector("#item" + index)
        .getBoundingClientRect();
      let height = rect1.top - rect0.top;
      console.log(height);

      this.$refs.currentSale.scrollTop = height;
      this.$refs.currentListSale.scrollTop = height;
    },

    onFacilityClick(item) {
      this.$refs.webref.contentWindow.postMessage(
        { type: "2", state: !item.active, idx: item.idx },
        "*"
      );
    },

    onLoadEnd() {
      if (this.$store.getters.filter.lat == 0) {
        this.$store.getters.filter.lat = this.myinfo.latitude;
        this.$store.getters.filter.lng = this.myinfo.longitude;
      }

      this.$refs.webref.contentWindow.postMessage(
        {
          type: "1",
          lat: this.myinfo.latitude,
          lon: this.myinfo.longitude,
          lastLat: this.$store.getters.filter.lat,
          lastLon: this.$store.getters.filter.lng,
          level: this.$store.getters.filter.zoom_level,
        },
        "*"
      );

      this.$store.getters.fcItems[0].map((item, idx) => {
        this.$refs.webref.contentWindow.postMessage(
          { type: "2", state: item.active, idx: item.ic_active },
          "*"
        );
      });
      this.$store.getters.fcItems[1].map((item, idx) => {
        this.$refs.webref.contentWindow.postMessage(
          { type: "2", state: item.active, idx: item.ic_active },
          "*"
        );
      });

      if (this.$store.getters.filter.lat != 0) {
        setTimeout(() => {
          if (this.$store.getters.filter.keyword != "") {
            this.onMapSearch(true, true);
          } else {
            this.onMapSearch(false, false);
          }
        }, Math.max(0, INTRO_TIME / 2 - (new Date().getTime() - startTime)));
      } else {
        setTimeout(() => {
          if (this.$store.getters.filter.keyword != "") {
            this.onMapSearch(true, true);
          } else {
            this.onMapSearch(false, false);
          }
        }, Math.max(0, INTRO_TIME - (new Date().getTime() - startTime)));
      }
    },

    onMeal() {

    },

    join_string(string1, string2) {
      let result = string1;
      if (string2 === '') {
        return result;
      }

      if (result !== '') {
        result += " / ";
      }
      return result + string2;
    },
  },

  beforeDestroy() {
    this.$store.commit("initFilter");
    this.$store.commit("setBackupFilter");
    window.removeEventListener("message", this.onMessage);
  },
  mounted() {
    this.keyword = this.$store.getters.filter.keyword;
    this.$store.commit("initFilter");
    this.$store.commit("setBackupFilter");
    this.saleTop = this.saleHeight;
    this.saleListTop = this.saleListHeight;
    if (this.keyword === null || this.keyword === undefined)
      this.keyword = '';

    this.$store.commit("setTabIndex", this.$c.MAIN_TAB.MAP);
    this.$store.commit("setFilter", { keyword: this.keyword });
    this.$store.commit("setLoading", true);
    this.eventBus.$on("site_detail_like", this.onSiteDetailLike);
    this.eventBus.$on("sale_complete", this.onTFApply);

    if (this.$store.getters.filter.lat != 0) {
      setTimeout(() => {
        if (this.$store.getters.filter.keyword != "") {
          this.onSearch(true, true);
        } else {
          this.onSearch(false, false);
        }
      }, Math.max(0, INTRO_TIME / 2 - (new Date().getTime() - startTime)));
    } else {
      setTimeout(() => {
        if (this.$store.getters.filter.keyword != "") {
          this.onSearch(true, true);
        } else {
          this.onSearch(false, false);
        }
      }, Math.max(0, INTRO_TIME - (new Date().getTime() - startTime)));
    }

    window.addEventListener("message", this.onMessage, false);
  },

  computed: {
    itemHeight: (vm) => vm.$el.querySelector("#item0").clientHeight,
    saleHeight: (vm) => vm.$refs.currentSale.clientHeight,
    saleListHeight: (vm) => vm.$refs.currentListSale.clientHeight,
    hasCategoryFilter: (vm) => vm.$store.getters.filter.site_type != "",
    hasMaemulFilter: (vm) => vm.$store.getters.filter.maemul_type != "",
    hasRoomFilter: (vm) =>
      vm.$store.getters.filter.room_num != "" ||
      vm.$store.getters.filter.toilet_num != "" ||
      vm.$store.getters.filter.elevator != "" ||
      vm.$store.getters.filter.duplex != "" ||
      vm.$store.getters.filter.teras != "",
    hasShapeFilter: (vm) =>
      vm.$store.getters.filter.trans_type != "" ||
      vm.$store.getters.filter.sale_price_min != 0 ||
      vm.$store.getters.filter.sale_price_max != 1000 ||
      vm.$store.getters.filter.charter_price_min != 0 ||
      vm.$store.getters.filter.charter_price_max != 1000 ||
      vm.$store.getters.filter.invest_price_min != 0 ||
      vm.$store.getters.filter.invest_price_max != 100 ||
      vm.$store.getters.filter.monthly_rent_deposit_min != 0 ||
      vm.$store.getters.filter.monthly_rent_deposit_max != 200 ||
      vm.$store.getters.filter.monthly_rent_min != 0 ||
      vm.$store.getters.filter.monthly_rent_max != 200 ||
      vm.$store.getters.filter.safe_charter != "N" ||
      vm.$store.getters.filter.smb != "N" ||
      vm.$store.getters.filter.not_show_site_inquire != "N",
    hasAreaFilter: (vm) =>
      vm.$store.getters.filter.area_type != "" ||
      vm.$store.getters.filter.exclusive_area_min != 0 ||
      vm.$store.getters.filter.exclusive_area_max != 50 ||
      vm.$store.getters.filter.real_area_min != 0 ||
      vm.$store.getters.filter.real_area_max != 50,
    hasRFilter: (vm) =>
      vm.$store.getters.filter.fee_type != "" ||
      vm.$store.getters.filter.fee_trading_min != 0 ||
      vm.$store.getters.filter.fee_trading_max != 100 ||
      vm.$store.getters.filter.fee_charter_min != 0 ||
      vm.$store.getters.filter.fee_charter_max != 100 ||
      vm.$store.getters.filter.fee_invest_min != 0 ||
      vm.$store.getters.filter.fee_invest_max != 100,
    hasPeriodFilter: (vm) =>
      vm.$store.getters.filter.period_type != "" ||
      vm.$store.getters.filter.reg_date_start != 0 ||
      vm.$store.getters.filter.reg_date_end != 24 ||
      vm.$store.getters.filter.open_date_type != -1 ||
      vm.$store.getters.filter.open_date_start != 0 ||
      vm.$store.getters.filter.open_date_end != 50,
    hasFilter: (vm) =>
      vm.hasCategoryFilter ||
      vm.hasMaemulFilter ||
      vm.hasRoomFilter ||
      vm.hasShapeFilter ||
      vm.hasAreaFilter ||
      vm.hasRFilter ||
      vm.hasPeriodFilter ||
      vm.keyword != "",
    filterString(vm) {
      let result = '';

      const site_type = this.$store.getters.filter.site_type;
      result = vm.join_string(result, site_type === '' ? '' : i18n.t(site_type === 'O' ? "map.new_open_site_short" : "map.general_site_short"));
      result = vm.join_string(result, this.maemul_type);
      result = vm.join_string(result, vm.price);
      result = vm.join_string(result, vm.room_structure);

      return result;
    },
    maemul_type() {
      let maemul_type = this.$store.getters.filter.maemul_type
        ? this.$store.getters.filter.maemul_type
          .split(",")
          .filter((it) => {
            return !Utils.isEmptyOrNull(it);
          })
          .map((it) => {
            if (it == 2)
              return this.$c.MAEMUL_TYPE_MAP['' + it][0] + this.$c.MAEMUL_TYPE_MAP['' + it][1] + this.$c.MAEMUL_TYPE_MAP['' + it][2];
            else if (it == 3)
              return this.$c.MAEMUL_TYPE_MAP['' + it][0] + this.$c.MAEMUL_TYPE_MAP['' + it][4];
            else
              return this.$c.MAEMUL_TYPE_MAP['' + it][0] + this.$c.MAEMUL_TYPE_MAP['' + it][1];
          })
        : [];
      return maemul_type.length === 0 ? '' : maemul_type.join(',')
    },
    room_structure() {
      let room_num = 0;
      switch (this.$store.getters.filter.room_num) {
        case 0:
          room_num = 1;
          break;
        case 1:
          room_num = 1.5;
          break;
        case 2:
          room_num = 2;
          break;
        case 3:
          room_num = 3;
          break;
        case 4:
          room_num = 4;
          break;
      }

      let toilet_num = 0;
      switch (this.$store.getters.filter.toilet_num) {
        case 1:
          toilet_num = 1;
          break;
        case 2:
          toilet_num = 2;
          break;
        case 3:
          toilet_num = 3;
          break;
      }

      let result = '';
      if (room_num > 0) {
        result = result.concat(i18n.t("site_detail.room") + room_num);
        if (room_num === 4) {
          result = result.concat("↑");
        }
      }
      if (toilet_num > 0) {
        result = result.concat(Utils.isEmpty(result) ? '' : ', ');
        result = result.concat(i18n.t("site_detail.toilet1") + toilet_num);
        if (toilet_num === 3) {
          result = result.concat("↑");
        }
      }

      let room_type = '';
      if (this.$store.getters.filter.duplex === 'Y') {
        room_type = i18n.t("room_info_popup.duplex_short");
      }
      if (this.$store.getters.filter.teras === 'Y') {
        room_type = room_type.concat(Utils.isEmpty(room_type) ? '' : ', ');
        room_type = room_type.concat(i18n.t("site_detail.teras_short"));
      }

      if (room_type !== '') {
        result = result.concat(Utils.isEmpty(result) ? '' : ' / ');
        result = result.concat(room_type);
      }

      return result;
    },
    price() {
      let result = '';
      switch (this.$store.getters.filter.trans_type) {
        case 'T':
          result = i18n.t('room_info_popup.parcel_price1');
          break;
        case 'C':
          result = i18n.t('interest.charter');
          break;
        case 'I':
          result = i18n.t('interest.invest');
          break;
        case 'M':
          result = i18n.t('interest.monthly');
          break;
      }
      return result;
    }
  },
  inject: ["eventBus"],
  watch: {
    keyword() {
      this.$store.commit("setFilter", {
        keyword: this.keyword.replaceAll(" ", ""),
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../../assets/css/main/map/Map.scss";

.site-list-container {
  position: relative;
  height: calc(100vh - (62px + 36px + 80px));
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding-left: 5px;
  padding-right: 5px;
}
.map_gps_btn {
  width: 100%;
  height: 100%;
}
.back_btn {
  position: absolute;
  //top: 62px + 36px + 46px;
  top: 158px;
  z-index: 3;
}
.toggle_btn {
  border: 1px solid #bebdbd;
  background-color: white;
  font-size: $fs_12;
  color: #666666;
  font-family: $korean_gd_11_r;
}
.toggle_btn.selected {
  color: #073fba;
}
.active {
  color: $primary;
  border-color: $primary;
}

.current-sale {
  button, select {
    border-width: 0.5px;
    border-radius: 5px;
    border-color: #bebdbd;
  }
  .sort_btn {
    margin-right: 8px;
    font-size: $fs_16;
    font-family: $korean_gd_14_r;
    height: 35px;
    width: fit-content;
    padding: .2rem 1.4rem;
  }
  .active {
    color: $primary;
    border-color: $primary;
  }
}

.filter-tab {
  border-radius: 0;
  border: none;
  flex: 1;
  font-size: 1rem;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: $fs_18;
  font-family: $korean_gd_14_r;
}

.sort-site-select {
  border: none;
  background: transparent !important;
  font-size: 1rem;
  color: #457fff;
  height: 30px;
  padding: 0 10px;
  width: auto;
  font-size: 16px;
  font-family: 'KoreanGD15R';
}

.sort-site-split {
  width: 1px;
  height: 60%;
  background: #457fff;
}

.no_item {
  color: black;
  font-size: $fs_20;
  font-family: $korean_gd_14_r;
  margin-top: 20px;
  align-self: center;
}

</style>



// WEBPACK FOOTER //
// src/components/contents/main/map/Map.vue